import { getVoucherByCode } from "@/services/customer";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const savedCode = localStorage.getItem("qrCode");

export const fetchVoucherByCode = createAsyncThunk(
  "qr/fetchVoucherByCode",
  async ({ token, code }, { rejectWithValue }) => {
    try {
      const res = await getVoucherByCode(token, code);
      return res;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const qrSlice = createSlice({
  name: "qr",
  initialState: {
    code: savedCode || null,
    voucher: null,
    loading: false,
    error: null,
  },
  reducers: {
    setQrCode: (state, action) => {
      state.code = action.payload;
      state.voucher = null;   // ← naya code aate hi purana voucher saaf
      state.error = null;

      if (action.payload) {
        localStorage.setItem("qrCode", action.payload);
      } else {
        localStorage.removeItem("qrCode");
      }
    },
    clearQrCode: (state) => {
      state.code = null;
      state.voucher = null;
      state.error = null;
      localStorage.removeItem("qrCode");
    },
    clearVoucher: (state) => {
      state.voucher = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVoucherByCode.pending, (state) => {
        state.loading = true;
        state.voucher = null;  // ← loading shuru hote hi clear
        state.error = null;
      })
      .addCase(fetchVoucherByCode.fulfilled, (state, action) => {
        state.loading = false;
        state.voucher = action.payload;
      })
      .addCase(fetchVoucherByCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setQrCode, clearQrCode, clearVoucher } = qrSlice.actions;
export default qrSlice.reducer;